import axios from 'axios';
import { isLegacyConnectHealthDataResponseDto, isLegacySignupResponseDto, } from './models';
import { LuminateRuntimeException } from '../models';
export class LegacySignupApi {
    config;
    axios;
    static SIGNUP_RELATIONSHIP_VALIDATION_PATH = '/common/signup/validate/relationship';
    static LEGACY_SIGNUP_PATH = '/common/signup/createPatient';
    static LEGACY_CONNECT_HEALTH_DATA_PATH = '/patient/landing/confirmInfoWithNotificationCode';
    static UNEXPECTED_SIGNUP_RESPONSE_ERROR = 'Unexpected response from legacy signup API:';
    static UNEXPECTED_CONNECT_RESPONSE_ERROR = 'Unexpected response from legacy connect API:';
    static UNEXPECTED_RESPONSE_FORMAT = 'Invalid response format:';
    static UNEXPECTED_SIGNUP_RELATIONSHIP_TYPE_VALIDATION_RESPONSE = 'Unexpected response from legacy signup relationship type validation API:';
    static UNEXPECTED_ERROR_FORMAT = 'Unexpected error:';
    static UNEXPECTED_HTTP_STATUS = 'HTTP';
    static UNKNOWN_STATUS = 'unknown';
    static NO_RESPONSE_BODY = 'No response body';
    static APPLICATION_JSON_CONTENT_TYPE = { 'Content-Type': 'application/json' };
    constructor(config, axios) {
        this.config = config;
        this.axios = axios;
    }
    static create = ({ apiBaseUrl, signupPath = LegacySignupApi.LEGACY_SIGNUP_PATH, connectPath = LegacySignupApi.LEGACY_CONNECT_HEALTH_DATA_PATH, validateRelationshipPath = LegacySignupApi.SIGNUP_RELATIONSHIP_VALIDATION_PATH, }, axiosInstance) => {
        if (!axiosInstance) {
            axiosInstance = axios.create({ headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
        }
        return new LegacySignupApi({ apiBaseUrl, signupPath, connectPath, validateRelationshipPath }, axiosInstance);
    };
    signup = async (request) => {
        let data;
        try {
            const response = await this.axios.post(`${this.config.apiBaseUrl}${this.config.signupPath}`, request);
            data = response.data;
        }
        catch (error) {
            this.axiosErrorHandler(error, LegacySignupApi.UNEXPECTED_SIGNUP_RESPONSE_ERROR);
        }
        if (!isLegacySignupResponseDto(data)) {
            throw new LuminateRuntimeException(`${LegacySignupApi.UNEXPECTED_SIGNUP_RESPONSE_ERROR} ${LegacySignupApi.UNEXPECTED_RESPONSE_FORMAT} ${JSON.stringify(data)}`);
        }
        return data;
    };
    connect = async (request) => {
        let data;
        try {
            const response = await this.axios.post(`${this.config.apiBaseUrl}${this.config.connectPath}`, request);
            data = response.data;
        }
        catch (error) {
            this.axiosErrorHandler(error, LegacySignupApi.UNEXPECTED_CONNECT_RESPONSE_ERROR);
        }
        if (!isLegacyConnectHealthDataResponseDto(data)) {
            throw new LuminateRuntimeException(`${LegacySignupApi.UNEXPECTED_CONNECT_RESPONSE_ERROR} ${LegacySignupApi.UNEXPECTED_RESPONSE_FORMAT} ${JSON.stringify(data)}`);
        }
        return data;
    };
    validateRelationship = async (request) => {
        try {
            await this.axios.post(`${this.config.apiBaseUrl}${this.config.validateRelationshipPath}`, request, {
                headers: LegacySignupApi.APPLICATION_JSON_CONTENT_TYPE,
            });
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.response?.status === 422) {
                    return error.response.data;
                }
                else {
                    this.axiosErrorHandler(error, LegacySignupApi.UNEXPECTED_SIGNUP_RELATIONSHIP_TYPE_VALIDATION_RESPONSE);
                }
            }
        }
    };
    axiosErrorHandler = (error, message) => {
        if (axios.isAxiosError(error)) {
            const status = error.response?.status ?? LegacySignupApi.UNKNOWN_STATUS;
            const errorData = error.response?.data ?? LegacySignupApi.NO_RESPONSE_BODY;
            throw new LuminateRuntimeException(`${message} ${LegacySignupApi.UNEXPECTED_HTTP_STATUS} ${status}: ${JSON.stringify(errorData)}`, {
                cause: error,
            });
        }
        throw new LuminateRuntimeException(`${message} ${LegacySignupApi.UNEXPECTED_ERROR_FORMAT} ${String(error)}`, {
            cause: error instanceof Error ? error : undefined,
        });
    };
}
